import {GameSteps, Locale, SyndicatesType} from "data/enums";
import {ILightPredictionNew} from "data/stores/light_predictions/light_predictions.store";

export const SITE_URL = process.env.REACT_APP_SITE_URL || "";
export const API_URL = process.env.REACT_APP_API_URL || "";
export const JSON_URL = process.env.REACT_APP_JSON_URL || "";
export const CONTENT_JSON_URL = process.env.REACT_APP_CONTENT_JSON_URL || "";
export const BASE_URL = process.env.REACT_APP_BASE_URL || "/";
export const SENTRY_DSN_URL = process.env.REACT_APP_SENTRY_DSN_URL;
export const SHARE_URL = process.env.REACT_APP_SHARE_URL || "";
export const IMAGES_URL = process.env.REACT_APP_IMAGES_URL || "";
export const GIGYA_KEY = process.env.REACT_APP_GIGYA_KEY || "";
export const NFL_SIGN_IN_PATH = process.env.REACT_APP_GIGYA_SIGN_IN_PATH || "";
export const IS_SKIP_SSO = JSON.parse(process.env.REACT_APP_IS_SKIP_SSO || "false") as boolean;
export const NFL_ACCOUNT_URL = process.env.REACT_APP_NFL_ACCOUNT_URL || "";
export const IS_SEASON_END = JSON.parse(process.env.REACT_APP_END_SEASON || "false") as boolean;
export const LP_TUTORIAL = "LP_tutorial";
export const HP_TUTORIAL = "HP_tutorial";
export const LP_PATH = "/pick-by-seed";
export const HP_PATH = "/game-by-game";
export const OFF_SEASON_PATH = "/off-season";
export const SYNDICATE = (process.env.REACT_APP_SYNDICATE || SyndicatesType.US) as SyndicatesType;
export const SECRET_PAGE_KEY = process.env.REACT_APP_SECRET_PAGE_KEY || "";

export const IS_PROD = process.env.REACT_APP_ENVIRONMENT === "production";

const locales = {
	[SyndicatesType.US]: Locale.EN_US,
	[SyndicatesType.AU]: Locale.EN_US,
	[SyndicatesType.FR]: Locale.FR_FR,
	[SyndicatesType.DE]: Locale.DE_DE,
	[SyndicatesType.CA]: Locale.EN_US,
	[SyndicatesType.BR]: Locale.PT_BR,
	[SyndicatesType.UK]: Locale.EN_US,
};

export const LOCALE = locales[SYNDICATE] || locales[SyndicatesType.US];
export const LOCALES = JSON.parse(process.env.REACT_APP_LOCALES || "[]") as string[];
export const ALLOWED_GEOLOCATIONS = JSON.parse(
	process.env.REACT_APP_ALLOWED_GEOLOCATIONS || "[]"
) as string[];

export const EMAIL_REGEXP = "\\S+@\\S+\\.\\S+";
export const PASSWORD_PATTERN =
	"^((?=.*?\\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[-!@#$%^&*()_+|~=`{}\\[\\]:\";'<>?,.\\/])).{8,}$";

export const PASSWORD_REQUIREMENTS =
	"Password must include 8 characters, including 1 upper case character, 1 number and 1 special character";

export const NFC_PICK_STEPS = [
	GameSteps.NFC_EAST,
	GameSteps.NFC_NORTH,
	GameSteps.NFC_SOUTH,
	GameSteps.NFC_WEST,
];

export const NFC_GAME_STEPS = [...NFC_PICK_STEPS, GameSteps.NFC_SEEDING, GameSteps.NFC_WILD_CARD];

export const AFC_PICK_STEPS = [
	GameSteps.AFC_EAST,
	GameSteps.AFC_NORTH,
	GameSteps.AFC_SOUTH,
	GameSteps.AFC_WEST,
];

export const AFC_GAME_STEPS = [...AFC_PICK_STEPS, GameSteps.AFC_SEEDING, GameSteps.AFC_WILD_CARD];

export const GAME_STEPS = [...NFC_GAME_STEPS, ...AFC_GAME_STEPS];

export const DEFAULT_LIGHT_PREDICTION: ILightPredictionNew = {
	nfc: [
		{
			type: GameSteps.NFC_EAST,
			position: 1,
			squadId: 0,
		},
		{
			type: GameSteps.NFC_NORTH,
			position: 2,
			squadId: 0,
		},
		{
			type: GameSteps.NFC_SOUTH,
			position: 3,
			squadId: 0,
		},
		{
			type: GameSteps.NFC_WEST,
			position: 4,
			squadId: 0,
		},
		{
			type: GameSteps.NFC_WILD_CARD,
			position: 5,
			squadId: 0,
		},
		{
			type: GameSteps.NFC_WILD_CARD,
			position: 6,
			squadId: 0,
		},
		{
			type: GameSteps.NFC_WILD_CARD,
			position: 7,
			squadId: 0,
		},
	],
	afc: [
		{
			type: GameSteps.AFC_EAST,
			position: 1,
			squadId: 0,
		},
		{
			type: GameSteps.AFC_NORTH,
			position: 2,
			squadId: 0,
		},
		{
			type: GameSteps.AFC_SOUTH,
			position: 3,
			squadId: 0,
		},
		{
			type: GameSteps.AFC_WEST,
			position: 4,
			squadId: 0,
		},
		{
			type: GameSteps.AFC_WILD_CARD,
			position: 5,
			squadId: 0,
		},
		{
			type: GameSteps.AFC_WILD_CARD,
			position: 6,
			squadId: 0,
		},
		{
			type: GameSteps.AFC_WILD_CARD,
			position: 7,
			squadId: 0,
		},
	],
};

export const SB_LINK = {
	[SyndicatesType.US]: "https://superbowlchallenge.nfl.com/",
	[SyndicatesType.UK]: "https://superbowlchallenge.co.uk/",
	[SyndicatesType.FR]: "https://superbowlchallenge.france.nfl.com/",
	[SyndicatesType.BR]: "https://superbowlchallenge.com.br/",
	[SyndicatesType.AU]: "https://www.superbowlchallenge.com.au/",
	[SyndicatesType.CA]: "https://superbowlchallenge.canada.nfl.com/",
	[SyndicatesType.DE]: "https://superbowlchallenge.sport.de/",
}[SYNDICATE];
